import React from "react";

// TikTok brand icon (inline SVG since lucide-react doesn't include it reliably).
// Uses currentColor so it inherits text-color from parent.
export default function TikTokIcon({ size = 20, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M19.321 5.562a5.124 5.124 0 0 1-3.03-1.023 5.13 5.13 0 0 1-1.976-3.539h-3.376v13.687a3.093 3.093 0 0 1-5.559 1.867 3.093 3.093 0 0 1 2.475-4.951c.316 0 .62.048.906.137V8.31a6.532 6.532 0 0 0-.906-.063 6.51 6.51 0 1 0 6.51 6.51V8.16a8.485 8.485 0 0 0 4.956 1.585V6.37c-.001 0 0 0 0-.808z" />
    </svg>
  );
}
